import { createContext } from "react";

export const userTypes = {
  admin: "admin",
  doctor: "doctor",
  patient: "patient",
  unAuthenticated: "unAuthenticated",
};

export const UserTypeContext = createContext({
  type: userTypes.unAuthenticated,
  changeType: (type) => {},
});
